import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollManager handles scrolling behavior on route changes.
 * - Scrolls to top on new navigation (PUSH) or replacement (REPLACE).
 * - Preserves scroll position on back/forward (POP) by letting the browser handle it.
 * - Also handles scrolling to top when query parameters (like pagination) change.
 */
export default function ScrollManager() {
    const location = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        // We only want to scroll to top if it's a new navigation or a replacement.
        // If it's a POP (back/forward button), we want to preserve the scroll position.
        // However, if the query params changed (pagination), we likely want to scroll to top 
        // even if it was somehow a POP (simulated), but usually pagination is PUSH.

        // Check if path or search changed.
        // Ideally, for pagination (same path, diff search), we ALWAYS want top.
        // For navigation to new page (diff path), we want top if PUSH.

        if (navType !== 'POP') {
            window.scrollTo(0, 0);
        } else {
            // It is POP.
            // But did we change query params only? (Pagination via back button?)
            // Actually if we go Prompt -> Back to Browse (Page 2), it's POP.
            // We WANT to stay at previous scroll position.
            // So POP should generally NOT scroll to top.
        }
    }, [location.pathname, location.search, navType]);

    return null;
}
